export default "__VITE_ASSET__xe3R0Nn9__"